var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5455 1.4464H9.17673L8.85091 0.800009C8.60436 0.311064 8.10109 0.00195312 7.55055 0.00195312H1.45455C0.650909 0.00195312 0 0.648342 0 1.4464V11.5575C0 12.3556 0.650909 13.002 1.45455 13.002H2.18182C2.58327 13.002 2.90909 12.6784 2.90909 12.2797V11.5575C2.90909 11.1588 3.23491 10.8353 3.63636 10.8353C4.03782 10.8353 4.36364 11.1588 4.36364 11.5575V12.2797C4.36364 12.6784 4.68945 13.002 5.09091 13.002H10.9091C11.3105 13.002 11.6364 12.6784 11.6364 12.2797V11.5575C11.6364 11.1588 11.9622 10.8353 12.3636 10.8353C12.7651 10.8353 13.0909 11.1588 13.0909 11.5575V12.2797C13.0909 12.6784 13.4167 13.002 13.8182 13.002H14.5455C15.3491 13.002 16 12.3556 16 11.5575V2.89084C16 2.09279 15.3491 1.4464 14.5455 1.4464ZM5.09091 4.33529H10.9091C11.2029 4.33529 11.4531 4.51006 11.568 4.75923L8 6.9649L4.43927 4.74912C4.55636 4.50573 4.80145 4.33529 5.09091 4.33529ZM11.6364 8.66862C11.6364 9.06729 11.3105 9.39084 10.9091 9.39084H5.09091C4.68945 9.39084 4.36364 9.06729 4.36364 8.66862V6.32718L7.22982 8.11106C7.70109 8.40429 8.29891 8.40501 8.77091 8.11323L11.6364 6.34234V8.66862Z",
    fill: "black",
    fillOpacity: 0.54
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIcon);
export default __webpack_public_path__ + "static/media/message-icon.61e2d552f279129e55308b6a60838b75.svg";
export { ForwardRef as ReactComponent };